import React, { useState } from 'react';
import CourseResourcePage from './CourseResourcePage';
import CourseResourceDetailPage from './CourseResourceDetailPage';

type CourseResourceHubProps = {
  spaceId: string;
  spaceProductId: string;
};

/** 课程资源产品页：列表与详情切换 */
const CourseResourceHub: React.FC<CourseResourceHubProps> = ({ spaceId, spaceProductId }) => {
  const [courseId, setCourseId] = useState<string | null>(null);

  if (courseId) {
    return (
      <CourseResourceDetailPage
        spaceId={spaceId}
        spaceProductId={spaceProductId}
        courseId={courseId}
        onBack={() => setCourseId(null)}
      />
    );
  }

  return (
    <CourseResourcePage
      spaceId={spaceId}
      spaceProductId={spaceProductId}
      onOpenCourse={setCourseId}
    />
  );
};

export default CourseResourceHub;
